var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickMyclassWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 3.33333C6.66667 4.25381 5.92047 5 5 5C4.07952 5 3.33333 4.25381 3.33333 3.33333C3.33333 2.41286 4.07952 1.66667 5 1.66667C5.92047 1.66667 6.66667 2.41286 6.66667 3.33333ZM4.16667 13.3333V18.3333H2.5V8.33333C2.5 6.95263 3.61929 5.83333 5 5.83333C5.68382 5.83333 6.30353 6.10788 6.75488 6.55278L8.73358 8.42142L10.6609 6.49408L11.8394 7.67259L8.76675 10.7453L7.5 9.54892V18.3333H5.83333V13.3333H4.16667ZM8.33333 4.16667H15.8333V11.6667H8.33333V13.3333H11.9712L14.3241 18.3333H16.1661L13.8132 13.3333H16.6667C17.1269 13.3333 17.5 12.9603 17.5 12.5V3.33333C17.5 2.8731 17.1269 2.5 16.6667 2.5H8.33333V4.16667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickMyclassWhite);
export default __webpack_public_path__ + "static/media/quick-myclass-white.bae89d3908c1d9cc38e7ae945da20718.svg";
export { ForwardRef as ReactComponent };